export default __webpack_public_path__ + "static/media/Vector.643ef296.svg";